import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store.ts";
import {AxiosError} from "axios";
import {actualPublicationService} from "../services/actualPublications-service.ts";
import {IActualPublicationsResponse} from "../models/ActualPublicationsResponse.ts";
import {getPostTC} from "./post-reducer.ts";
import {IUpdateStatusPublicationParams} from "../models/SinglePublicationsResponse.ts";
import {successToastify} from "../../utils/Utils.ts";
import {CampaignScheduleStatus} from "../../constants/enums.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";
import {t} from "i18next";

type  InitialStateType = {
    data: IActualPublicationsResponse | null
    isLoading: boolean
};

const initialState: InitialStateType = {
    data: null,
    isLoading: false,
}

const slice = createSlice({
    name: "actualPublications",
    initialState: initialState,
    reducers: {
        setActualPublicationsData: (state: InitialStateType, action: PayloadAction<IActualPublicationsResponse>) => {
            state.data = action.payload
        },
        updateActualPublicationsStatus: (state: InitialStateType, action: PayloadAction<CampaignScheduleStatus>) => {
            if (state.data) {
                state.data.status = action.payload
            }
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
    },
});
export const actualPublicationsReducer = slice.reducer;
export const actualPublicationsActions = slice.actions;

export const getActualPublicationsTC = (id: string): AppThunk<Promise<IActualPublicationsResponse | void>> =>
    async (dispatch) => {
        dispatch(actualPublicationsActions.setIsLoading(true));
        try {
            const res = await actualPublicationService.fetchActualPublications(id);
            dispatch(actualPublicationsActions.setActualPublicationsData(res.data))
            if (res.data.post_id) {
                await dispatch(getPostTC(res.data.post_id))
            }
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(t('errors.getActualPublication'), 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(actualPublicationsActions.setIsLoading(false));
        }
    };

export const launchActualPublicationTC = (id: string, params: IUpdateStatusPublicationParams): AppThunk<Promise<string | void>> =>
    async (dispatch) => {
        // dispatch(actualPublicationsActions.setIsLoading(true));
        try {
            const res = await actualPublicationService.updatePendingPublications(id, params);
            dispatch(actualPublicationsActions.updateActualPublicationsStatus(params.status))
            successToastify(t('modals.launchPublication.successResponse'), 'bottom-center', 'main');
            return res.data

        } catch (err) {
            showCustomErrorToast(t('modals.launchPublication.errorResponse'), 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(actualPublicationsActions.setIsLoading(false));
        }
    };
export const declineActualPublicationTC = (id: string, params: IUpdateStatusPublicationParams): AppThunk<Promise<string | void>> =>
    async (dispatch) => {
        // dispatch(actualPublicationsActions.setIsLoading(true));
        try {
            const res = await actualPublicationService.updatePendingPublications(id, params);
            dispatch(actualPublicationsActions.updateActualPublicationsStatus(params.status))
            successToastify(t('modals.stopPublication.successResponse'), 'bottom-center', 'main');
            return res.data

        } catch (err) {
            showCustomErrorToast(t('modals.stopPublication.errorResponse'), 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(actualPublicationsActions.setIsLoading(false));
        }
    };
